import ApplyContent from 'components/apply-shared/apply-content';
import { ButtonGroup, Flex, List, Text } from '@chakra-ui/react';
import ListItem from 'common/components/list-item';
import {
  FaHouseChimney,
  FaFileSignature,
  FaPerson,
  FaListCheck,
} from 'react-icons/fa6';
import Button from 'common/components/button';
import { useNavigate } from 'react-router-dom';

const StartPurchase = ({ onNextClick, isLoading, planId }) => {
  const navigate = useNavigate();
  return (
    <div className='flex flex-col w-full h-full'>
      <ApplyContent>
        <Flex className='flex-col gap-4 text-center items-center h-full p-8'>
          <Text className='text-2xl font-medium'>
            Get ReLease Coverage
          </Text>
          <Text className='text-base text-gray-500 max-w-md'>
            We'll ask a few questions about your lease to get you covered. It
            only takes a few minutes.
          </Text>
          <List className='flex flex-col w-fit text-left gap-4 max-w-md p-6 rounded-lg border border-gray-200 my-6'>            
            <ListItem title='Rental Details' ListIcon={FaHouseChimney} line>
              <Text className='text-base text-gray-500'>
                Let us know where you're planning to rent, and whether
                it's at a ReLease-Enabled Community.
              </Text>
            </ListItem>
            <ListItem title='Lease Details' ListIcon={FaFileSignature} line>
              <Text className='text-base text-gray-500'>
                Provide your lease details like your monthly rent, lease term,
                and layout.
              </Text>
            </ListItem>
            <ListItem title='Personal Details' ListIcon={FaPerson} line>
              <Text className='text-base text-gray-500'>
                Provide some personal details. This will help us determine your
                eligibility for a ReLease plan.
              </Text>
            </ListItem>
            <ListItem title='Choose Payment Option' ListIcon={FaListCheck}>
              <Text className='text-base text-gray-500'>
                Choose the option that works best for you.
              </Text>
            </ListItem>
          </List>
          <ButtonGroup>
            <Button
              onClick={() => onNextClick()}
              title='Get Started'
              wFull={false}
              size='lg'
              loading={isLoading}
            />
          </ButtonGroup>
          {!planId && (
            <>
              <div className='flex w-full max-w-lg h-[1px] bg-gray-200 relative items-center justify-center my-4'>
                <Text className='text-sm text-gray-500 bg-white px-3'>
                  Haven't decided on a rental yet?
                </Text>
              </div>
              <ButtonGroup className='justify-center items-center flex-col sm:flex-row gap-4 sm:gap-1 pb-8'>
                <Button
                  onClick={() => navigate('/dashboard/plans/quote')}
                  theme='secondary'
                  title='Get a Free Quote First'
                />
              </ButtonGroup>
            </>
          )}
        </Flex>
      </ApplyContent>
    </div>
  );
};

export default StartPurchase;
